﻿import { Box, TableRow } from "@mui/material";
import { DataControllerRecordModel } from "./DataControllerRecord.types";
import { DotLegalEmptyState, DotLegalTableWithControls } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "../localization/useTranslation";
import EmptyRecord from "../record/emptyRecord.svg?react";
import DataControllerRecordCells from "./DataControllerRecordCells";
import { getDataControllerRecordHeaders } from "./dataControllerRecordHeaders";

export interface IDataControllerRecordProps {
    rows: Array<DataControllerRecordModel>;
    isLoading: boolean;
    isExtended: boolean;
    hasData: boolean;
}

function DataControllerRecord(props: IDataControllerRecordProps) {
    const { translateString } = useTranslation();

    return (
        <Box>
            {props.hasData ? (
                <DotLegalTableWithControls
                    headers={getDataControllerRecordHeaders(props.isExtended, translateString)}
                    defaultOrderBy={"name"}
                    defaultOrder={"asc"}
                    isLoading={props.isLoading}
                    hideRowsPerPage
                    getUserSpecificPageLength={() => 30}
                    clickableRows={false}
                    data={props.rows}
                    emptyText={translateString("noProcessingActivitesMatchesQuery")}
                    labelRowsPerPage={translateString("showEntites")}
                    labelSearch={translateString("search")}
                    noOptionsLabel={translateString("noOptions")}
                    paginationLabelOf={translateString("labelOf")}
                    renderRow={(row) => (
                        <TableRow key={row.id}>
                            <DataControllerRecordCells row={row} isExtended={props.isExtended} />
                        </TableRow>
                    )}
                />
            ) : (
                <DotLegalEmptyState icon={<EmptyRecord />} text={translateString("noProcessingActivitesMatchesQuery")} />
            )}
        </Box>
    );
}

export default DataControllerRecord;
